import { render, staticRenderFns } from "./CircleSliderText.vue?vue&type=template&id=3888db92&"
import script from "./CircleSliderText.vue?vue&type=script&lang=js&"
export * from "./CircleSliderText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports